export function getSourceByPath(path?: 'home' | 'ai_flow' | 'studio' | 'project' | undefined) {
  let { pathname } = window.location;
  if (path) {
    pathname = pathname === '/' ? '/official_page' : path;
  } else {
    pathname = '/official_page';
  }
  return pathname;
}
